<template>
    <BreadCrumb PageTitle="Liste des niveaux" />
    <ListeNiveau />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeNiveau from "../../components/Niveau/ListeNiveau.vue";

  
    export default defineComponent({
      name: "ListeNiveauPage",
      components: {
        BreadCrumb,
        ListeNiveau,
      },
    });
  </script>